export const fullResetEventType = "fullReset";

export function triggerFullReset() {
    const evt = new CustomEvent(fullResetEventType);
    document.dispatchEvent(evt);
}

// this is where it is to avoid circularities. the rpc codegen code
// must not become a dependency, so it's a mistake to know about setlists
// here, as they will of necessity need types from inside codegen.
// we can't rely on any codegen types here either. both tqc and setlist
// are responsible for registering themselves via listen.
//export function ResetProvider({children}: PropsWithChildren) {
//const clearTqc = useQueryCacheClearer().clear;
// since these two are called blindly, don't use death traps as zero values.
// use NULLFUNC.
// const resetDispatchMesh = useResetDispatchMesh();
// const resetVenueOverview = useResetVenueOverview();
// const resetSetlist = useResetSetlist();
// const performReset = useCallback(() => {
//     clearTqc();
//     resetSetlist();
//     // resetDispatchMesh();
//     // resetVenueOverview();
//     return Promise.resolve();
// }, [clearTqc, resetSetlist]);
// const resetListenerMgr = useListenerList();
// const resetter = useMemo(() => {
//     return {
//         reset: () => {
//             resetListenerMgr.notify({})
//         },
//         listen: (onReset: Listener<unknown>) => {
//             return resetListenerMgr.listen(onReset);
//         },
//     }
// }, [resetListenerMgr]);
//
// return <FullResetContext value={resetter}>{children}</FullResetContext>
//}

// export interface Resetter {
//     reset: () => void,
//     listen: (onReset: Listener<unknown>) => Unlistener,
// }
//
// const FullResetContext = createContext<Resetter>({
//     reset: () => {
//         throw new Error("outside reset scope");
//     },
//     listen: () => {
//         throw new Error("outside reset scope");
//     },
// });
//
// export function useFullReset() {
//     const rv = useContext(FullResetContext);
//     return rv;
//}

